// extracted by mini-css-extract-plugin
export default {"breadcrumb":"sol-kQ2Ucw_y","breadcrumbHeaderWrapper":"sol-QaVxEW31"};